import { ISubmission } from '../helpers';

export const DEFAULT_SUBMISSION:ISubmission = {
    ComponentId: '',
    Properties: []
};


// WEBPACK FOOTER //
// ./source/ts/constants/submission.ts